import { css } from '@emotion/react';

const FONT = `'Neue Haas Grotesk Display Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`;

export const profilePopoverCSS = () => css`
    font-family: ${FONT};

    &.pp-backdrop {
        position: fixed;
        inset: 0;
        background: rgba(15, 23, 42, 0.15);
        backdrop-filter: blur(2px);
        z-index: 999;
    }

    &.pp-panel {
        position: absolute;
        top: calc(100% + 8px);
        right: 0;
        width: 320px;
        max-height: calc(100vh - 120px);
        background: #ffffff;
        border-radius: 14px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.14), 0 2px 8px rgba(0, 0, 0, 0.06);
        border: 1px solid #e2e8f0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        z-index: 1000;
    }

    .pp-header {
        padding: 14px 16px;
        border-bottom: 1px solid #f1f5f9;
        background: #ffffff;
    }
    .pp-title {
        margin: 0;
        font-size: 1rem;
        font-weight: 700;
        color: #0f172a;
    }

    .pp-list {
        padding: 10px 8px 12px;
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .pp-divider {
        height: 1px;
        background: #f1f5f9;
        margin: 6px 8px;
    }

    .pp-section-label {
        margin: 0;
        padding: 4px 10px 6px;
        font-size: 0.68rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #94a3b8;
    }

    .pp-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px;
        border-radius: 10px;
        width: 100%;
        text-align: left;
        border: none;
        outline: none;
        background: transparent;
        font-family: ${FONT};
        transition: background-color 0.15s, color 0.15s;
    }
    .pp-item.active {
        background: rgba(50, 184, 223, 0.06);
        border: 1px solid rgba(50, 184, 223, 0.18);
    }
    .pp-item.clickable {
        cursor: pointer;
    }
    .pp-item.clickable:hover {
        background: #f8fafc;
    }
    .pp-item.clickable:hover .pp-item-name {
        color: #32b8df;
    }
    .pp-item.clickable.danger:hover {
        background: #fef2f2;
    }
    .pp-item.clickable.danger:hover .pp-item-name {
        color: #dc2626;
    }

    .pp-avatar {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background: linear-gradient(135deg, #3b82f6, #32b8df);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-weight: 700;
        font-size: 0.82rem;
        flex-shrink: 0;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
        letter-spacing: 0.5px;
    }

    .pp-icon {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        background: #f1f5f9;
        color: #475569;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        flex-shrink: 0;
    }
    .pp-icon.danger {
        background: #fef2f2;
        color: #dc2626;
    }

    .pp-item-text {
        display: flex;
        flex-direction: column;
        gap: 2px;
        flex: 1;
        min-width: 0;
    }
    .pp-item-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 6px;
    }
    .pp-item-name {
        font-size: 0.88rem;
        font-weight: 600;
        color: #0f172a;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .pp-item-sub {
        font-size: 0.72rem;
        color: #94a3b8;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .pp-active-badge {
        font-size: 0.68rem;
        font-weight: 600;
        color: #32b8df;
        background: rgba(50, 184, 223, 0.1);
        padding: 1px 8px;
        border-radius: 10px;
        flex-shrink: 0;
    }

    .pp-role-chip {
        font-size: 0.65rem;
        font-weight: 600;
        color: #1d4ed8;
        background: #dbeafe;
        padding: 2px 8px;
        border-radius: 999px;
        width: fit-content;
        margin-top: 3px;
    }

    .pp-chevron {
        font-size: 0.7rem;
        color: #cbd5e1;
        flex-shrink: 0;
    }
    .pp-item.clickable:hover .pp-chevron {
        color: #32b8df;
    }
    .pp-item.clickable.danger:hover .pp-chevron {
        color: #dc2626;
    }

    @media (max-width: 650px) {
        &.pp-panel {
            width: calc(100vw - 2rem);
            right: -0.75rem;
        }
    }
`;
